<template>
  <div>
    <nx-search
      ref="searchForm"
      :source="searchForm"
      :config="searchConfig"
    >
      <div slot="search">
        <el-button type="primary" @click="$refs.nxTable.search(1)">查询</el-button>
        <el-button @click="reset()">重置</el-button>
      </div>
    </nx-search>
    <nx-table
      ref="nxTable"
      :data="tableData"
      table-title="基础数据列表"
      @search="search"
    >
      <template slot="operation">
        <el-button v-perm="'/dataService/import'" type="primary" plain icon="iconfont icon-daoru_blue" @click="toggleImportDialog">导入</el-button>
      </template>
      <template slot="export">
        <div>说明：后台默认采用最后一次导入的基础数据</div>
      </template>
      <el-table-column label="基础数据类型" prop="dataType">
        <template slot-scope="{row}">
          {{ (dataTypes.find((item) => item.value === row.dataType) || {}).label }}
        </template>
      </el-table-column>
      <el-table-column label="版本" prop="version"></el-table-column>
      <el-table-column label="主机厂" prop="oem"></el-table-column>
      <el-table-column label="品牌/车系/车型" prop="brandName" min-width="160">
        <template slot-scope="{row}">
          {{ row.brand }}/{{ row.series }}/{{ row.mode }}
        </template>
      </el-table-column>
      <el-table-column label="适用阶段" prop="stage">
      </el-table-column>
      <el-table-column label="创建人" prop="createName"></el-table-column>
      <el-table-column label="导入时间" prop="createTime">
        <template slot-scope="scope">
          {{ $utils.formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="{row}">
          <el-button v-perm="'/dataService/detail'" type="text" @click="toggleDetailDialog({ status: true ,row})">详情</el-button>
          <el-button v-perm="'/dataService/export'" type="text" @click="handExport(row)">导出</el-button>
        </template>
      </el-table-column>
    </nx-table>

    <!-- 详情 -->
    <DetailDialog
      :visible.sync="detailDialogConfig.status"
      :config.sync="detailDialogConfig.config"
    ></DetailDialog>

    <!-- 导入 -->
    <ImportDialog
      :visible.sync="importDialogConfig.status"
      @onConfirm="$refs.nxTable.search()"
    ></ImportDialog>
  </div>
</template>
<script>
/**
 * name: 基础数据维护
 * author:苏金铃
 */
import DetailDialog from './component/detailDialog.vue';
import ImportDialog from './component/importDialog.vue';
import { getDataBaseList, faultExportList, canExportList } from '@/api/dataService/base.js';
import { dataTypes, stageTypes } from '../config.js';
export default {
  name: 'DataServiceBase',
  components: {
    DetailDialog,
    ImportDialog
  },
  props: {},
  data() {
    return {
      dataTypes,
      stageTypes,
      tableData: [],
      searchForm: {
        dataType: '', // 基础数据类型
        codes: '', // 品牌车系车型
        stage: '', // 适用阶段
        version: '', // 版本
        time: [] // 导入时间
      },
      detailDialogConfig: {
        status: false,
        config: {}
      },
      importDialogConfig: {
        status: false
      }
    };
  },
  computed: {
    searchConfig() {
      return [
        {
          key: 'dataType',
          component: 'el-select',
          span: 8,
          label: '基础数据类型:',
          data: [
            { label: '全部', value: '' },
            ...dataTypes
          ],
          props: {
            clearable: true,
            placeholder: '请选择'
          }
        },
        {
          key: 'stage',
          component: 'el-select',
          span: 8,
          label: '适用阶段:',
          data: [
            { label: '全部', value: '' },
            ...stageTypes
          ],
          props: {
            clearable: true,
            placeholder: '请选择'
          }
        },
        {
          key: 'codes',
          component: 'NxSelectBrandTree',
          label: '品牌/车系/车型:',
          span: 8
        },
        {
          key: 'version',
          component: 'el-input',
          span: 8,
          label: '版本:',
          props: {
            clearable: true,
            placeholder: '请输入版本'
          }
        },
        {
          key: 'time',
          component: 'el-date-picker',
          label: '导入时间:',
          span: 8,
          props: {
            clearable: true,
            valueFormat: 'timestamp',
            type: 'datetimerange',
            defaultTime: ['00:00:00', '23:59:59'],
            rangeSeparator: '-',
            startPlaceholder: '请选择开始时间',
            endPlaceholder: '请选择结束时间'
          }
        },
        {
          component: 'slot',
          slotName: 'search',
          span: 8
        }
      ];
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 重置搜索表单
    reset(hasSearch) {
      this.$refs.searchForm.resetFields();
      if (hasSearch) {
        this.$refs.nxTable.search(1);
      }
    },
    async search(pagination) {
      const { pageNum, pageSize } = pagination;
      const [startTime = '', endTime = ''] = this.searchForm.time || [];
      const [brand = '', series = '', mode = ''] = this.searchForm.codes || [];
      const params = {
        ...this.searchForm,
        startTime,
        endTime,
        brand,
        series,
        mode,
        pageNum,
        pageSize
      };
      delete params.codes;
      delete params.time;
      console.log(params);
      const { data } = await getDataBaseList(params);
      this.tableData = data.list;
      pagination.total = data.total;
    },
    toggleDetailDialog({ status = false, row = {}}) {
      this.detailDialogConfig = {
        status,
        config: {
          id: row.id,
          dataType: row.dataType
        }
      };
    },
    toggleImportDialog() {
      this.importDialogConfig.status = true;
    },
    // 导出
    async handExport(row) {
      const params = {
        baseId: row.id
      };
      if (Number(row.dataType) === 0) {
        // 0-CAN矩阵，1-故障字典
        await canExportList(params);
      }
      else {
        await faultExportList(params);
      }
      this.$message.success('导出任务已提交，请前往导出文件列表查看');
    }
  }
};
</script>
<style scoped lang="scss">
</style>
